import { render, staticRenderFns } from "./pollsNew.vue?vue&type=template&id=3c8fc722&scoped=true&"
import script from "./pollsNew.vue?vue&type=script&lang=js&"
export * from "./pollsNew.vue?vue&type=script&lang=js&"
import style0 from "./pollsNew.vue?vue&type=style&index=0&class=scss&lang=css&"
import style1 from "./pollsNew.vue?vue&type=style&index=1&id=3c8fc722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fc722",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VForm,VRadio,VRadioGroup,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8fc722')) {
      api.createRecord('3c8fc722', component.options)
    } else {
      api.reload('3c8fc722', component.options)
    }
    module.hot.accept("./pollsNew.vue?vue&type=template&id=3c8fc722&scoped=true&", function () {
      api.rerender('3c8fc722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/pollsNew.vue"
export default component.exports